import { z } from 'zod'

export const chatSearchResultSchema = z.object({
  chatId: z.string(),
  contactId: z.string(),
  source: z.string(),
  lastMessageDate: z.string().nullable().optional(),
  snippet: z.string(),
  matchedMessageId: z.string(),
  rank: z.number()
})

export const ddCaseSearchResultSchema = z.object({
  caseId: z.string(),
  caseAlias: z.string(),
  name: z.string(),
  propertyAddress: z.string().nullable(),
  status: z.string(),
  businessId: z.string(),
  matchedIn: z.enum(['case', 'case_notes', 'case_messages']),
  snippet: z.string(),
  rank: z.number()
})

export const searchResponseSchema = z.object({
  query: z.string(),
  chats: z.object({
    results: z.array(chatSearchResultSchema),
    hasMore: z.boolean()
  }),
  ddCases: z.object({
    results: z.array(ddCaseSearchResultSchema),
    hasMore: z.boolean()
  })
})

export type SearchResponse = z.infer<typeof searchResponseSchema>
export type ChatSearchResult = z.infer<typeof chatSearchResultSchema>
export type DdCaseSearchResult = z.infer<typeof ddCaseSearchResultSchema>
